"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = require("styled-components");

var _base = _interopRequireDefault(require("../../style/themes/base"));

var _browser = _interopRequireDefault(require("../../utils/helpers/browser"));

var _portrait = require("./portrait.style");

var _portrait2 = require("./portrait.config");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

let PortraitInitials = /*#__PURE__*/function (_React$Component) {
  _inherits(PortraitInitials, _React$Component);

  var _super = _createSuper(PortraitInitials);

  function PortraitInitials(...args) {
    var _this;

    _classCallCheck(this, PortraitInitials);

    _this = _super.call(this, ...args);

    _defineProperty(_assertThisInitialized(_this), "cachedImageDataUrl", null);

    return _this;
  }

  _createClass(PortraitInitials, [{
    key: "UNSAFE_componentWillReceiveProps",
    value:
    /** Invoked before a mounted component receives new props. */
    function UNSAFE_componentWillReceiveProps(nextProps) {
      const shouldClearCache = this.props.theme !== nextProps.theme || this.props.initials !== nextProps.initials || this.props.size !== nextProps.size || this.props.darkBackground !== nextProps.darkBackground;

      if (shouldClearCache) {
        this.cachedImageDataUrl = null;
      }
    }
    /** Generates a graphic with initials. */

  }, {
    key: "generateDataUrl",
    value: function generateDataUrl() {
      if (this.cachedImageDataUrl) {
        return this.cachedImageDataUrl;
      }

      const {
        theme,
        size,
        darkBackground
      } = this.props;
      const {
        textColor,
        bgColor
      } = (0, _portrait.getColorsForInitials)(theme, darkBackground);

      let canvas = _browser.default.getDocument().createElement("canvas");

      let context = canvas.getContext("2d");
      let {
        dimensions
      } = _portrait2.PORTRAIT_SIZE_PARAMS[size];
      dimensions -= 2; // Set canvas with & height

      canvas.width = dimensions;
      canvas.height = dimensions; // Select a font family to support different language characters
      // like Arial

      context.font = `${Math.round(canvas.width / 2.4)}px Lato, Arial`;
      context.textAlign = "center"; // Setup background and front color

      context = this.applyBackground(context, dimensions, bgColor);
      context = this.applyText(context, dimensions, textColor); // Set image representation in default format (png)

      const dataURI = canvas.toDataURL(); // Dispose canvas element

      canvas = null;
      this.cachedImageDataUrl = dataURI;
      return this.cachedImageDataUrl;
    }
    /** Applies the background colour to the canvas. */

  }, {
    key: "applyBackground",
    value: function applyBackground(canvasContext, dimensions, bgColor) {
      canvasContext.fillStyle = bgColor;
      canvasContext.fillRect(0, 0, dimensions, dimensions);
      return canvasContext;
    }
    /** Applies the initials text to the canvas. */

  }, {
    key: "applyText",
    value: function applyText(canvasContext, dimensions, textColor) {
      const letters = this.props.initials.slice(0, 3);
      canvasContext.fillStyle = textColor;
      canvasContext.fillText(letters.toUpperCase(), dimensions / 2, dimensions / 1.5);
      return canvasContext;
    }
    /** Renders the component. */

  }, {
    key: "render",
    value: function render() {
      const {
        size,
        shape,
        theme,
        ...otherProps
      } = this.props;
      return /*#__PURE__*/_react.default.createElement(_portrait.StyledPortraitInitials, _extends({
        "data-element": "initials",
        size: size,
        shape: shape,
        theme: theme
      }, otherProps), /*#__PURE__*/_react.default.createElement(_portrait.StyledPortraitInitialsImg, {
        src: this.generateDataUrl(),
        alt: this.props.alt
      }));
    }
  }]);

  return PortraitInitials;
}(_react.default.Component);

PortraitInitials.propTypes = {
  /** The theme to use. */
  theme: _propTypes.default.object,

  /** The user's initials to render. */
  initials: _propTypes.default.string.isRequired,

  /** The size of the initials image. */
  size: _propTypes.default.oneOf(["XS", "S", "M", "ML", "L", "XL", "XXL"]).isRequired,

  /** Use a dark background. */
  darkBackground: _propTypes.default.bool,

  /** The shape of the Portrait. */
  shape: _propTypes.default.oneOf(["circle", "square"]),

  /** The `alt` HTML string. */
  alt: _propTypes.default.string
};
PortraitInitials.defaultProps = {
  shape: "square",
  theme: _base.default
};

var _default = (0, _styledComponents.withTheme)(PortraitInitials);

exports.default = _default;